import React from 'react';
function AddressEnteredDisplay(_ref) {
  var address = _ref.address;
  return /*#__PURE__*/React.createElement("p", null, "What you have entered: ", /*#__PURE__*/React.createElement("br", null), address);
}
export default AddressEnteredDisplay;